import React from 'react';
import PropTypes from 'prop-types';

import CaregiverViewScene from '../../detail/CaregiverViewScene';

import backend from 'utils/backend';

const loadCaregiverProfile = (caregiverRn) => {
  return backend.loom.caregiver.getCaregiver(caregiverRn);
};

const loadScheduleByMonth = (caregiverRn, byMonths, loadCaregiverUpdates, options) => {
  return backend.loom.schedule.loadCaregiverMonths(caregiverRn, byMonths, loadCaregiverUpdates, options);
};

const LoomCaregiverView = (props) => {
  return (
    <CaregiverViewScene
      {...props}
      loadCaregiverProfile={loadCaregiverProfile}
      loadScheduleByMonth={loadScheduleByMonth}
      showAgreements={false}
    />
  );
};

LoomCaregiverView.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

export default React.memo(LoomCaregiverView);
